<template>
  <v-form class="form">
    <div class="inputBox">
      <label>{{
        localStorage.translations.pages['setting-personal_area'].labels['data-registraitsii']
      }}</label>
      <v-text-field
        class="noneDetails"
        :placeholder="
          localStorage.translations.pages['setting-personal_area'].labels['data-registraitsii']
        "
        v-model="employee.reg_date"
        height="46px"
        outlined
        disabled
      ></v-text-field>
    </div>
    <div class="inputBox">
      <label>{{
        localStorage.translations.pages['setting-personal_area'].labels['data-oformleniya']
      }}</label>
      <v-text-field
        class="noneDetails"
        :placeholder="
          localStorage.translations.pages['setting-personal_area'].labels['data-oformleniya']
        "
        v-model="employee.reg_date"
        height="46px"
        outlined
        disabled
      ></v-text-field>
    </div>
    <div class="inputBox">
      <label>{{
        localStorage.translations.pages['setting-personal_area'].labels['data-nachala-rabot']
      }}</label>
      <v-text-field
        class="noneDetails"
        v-model="employee.work_start_date"
        :placeholder="
          localStorage.translations.pages['setting-personal_area'].labels['data-nachala-rabot']
        "
        height="46px"
        outlined
        disabled
      ></v-text-field>
    </div>
    <div class="inputBox">
      <label>{{
        localStorage.translations.pages['setting-personal_area'].labels['data-okonchaniya-rabot']
      }}</label>
      <v-text-field
        class="noneDetails"
        :placeholder="
          localStorage.translations.pages['setting-personal_area'].labels['data-okonchaniya-rabot']
        "
        v-model="employee.work_end_date"
        height="46px"
        outlined
        disabled
      ></v-text-field>
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'AllDate',
  props: ['employee'],
  components: {},
  data: () => ({}),
  methods: {},
}
</script>

<style lang="scss" scoped>
.form {
  padding: 30px;
  background-color: white;
  border: 1px solid #bedbeb;
  border-radius: 4px;
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
</style>
